<section class="auth-page">

  <div class="auth-orb auth-orb--1"></div>
  <div class="auth-orb auth-orb--2"></div>

  <div class="auth-canvas">
    <div class="auth-card">

      <div class="auth-card-header">
        <a routerLink="/">
          <img src="assets/images/Logo ver 1.png" alt="Radwa Khallaf" class="auth-logo" />
        </a>
        <div class="auth-ornament">
          <span class="auth-orn-rule"></span>
          <span class="auth-orn-gem">✦</span>
          <span class="auth-orn-rule"></span>
        </div>
        <span class="auth-step-label">{{ 'login.welcome' | translate }}</span>
      </div>

      <form [formGroup]="loginForm" class="auth-form">

        <div class="form-group-lux">
          <label for="emailOrPhone">{{ 'login.email_label' | translate }}</label>
          <input
            type="text"
            id="emailOrPhone"
            formControlName="emailOrPhone"
            class="lux-input"
            [placeholder]="'login.email_placeholder' | translate"
            autocomplete="username"
          />
          <span class="field-error" *ngIf="loginForm.controls.emailOrPhone.touched && loginForm.controls.emailOrPhone.errors?.['required']">
            {{ 'login.err.required_email' | translate }}
          </span>
          <span class="field-error" *ngIf="loginForm.controls.emailOrPhone.errors?.['invalidEmailOrPhone']">
            {{ 'login.err.invalid_email' | translate }}
          </span>
        </div>

        <div class="form-group-lux">
          <div class="lux-label-row">
            <label for="password">{{ 'login.password_label' | translate }}</label>
            <a routerLink="/forget_pw" class="forgot-link">{{ 'login.forgot' | translate }}</a>
          </div>
          <input
            type="password"
            id="password"
            formControlName="password"
            class="lux-input"
            [placeholder]="'login.password_placeholder' | translate"
            autocomplete="current-password"
          />
          <span class="field-error" *ngIf="loginForm.controls.password.touched && loginForm.controls.password.errors?.['required']">
            {{ 'login.err.required_pw' | translate }}
          </span>
        </div>

        <button
          type="button"
          (click)="login()"
          class="btn-auth"
          [disabled]="loginForm.invalid"
        >
          {{ 'login.submit' | translate }}
        </button>

      </form>

      <p class="auth-switch">
        {{ 'login.no_account' | translate }}
        <a routerLink="/sign_up">{{ 'login.create' | translate }}</a>
      </p>

    </div>
  </div>

</section>
